import type { ReactElement } from 'react';
import React from 'react';
import type { PaletteTypes, SizeTypes, TagAlertProps } from './TagAlert.types';
import { TagAlertPalette, TagAlertSize } from './TagAlert.types';

import { Box } from './subcomponents/Box';
import { AlertIcon } from './subcomponents/AlertIcon';
import { TextParent } from './subcomponents/TextParent';

export const TagAlert = (props: TagAlertProps): ReactElement => {
  const {
    palette = TagAlertPalette.success as PaletteTypes,
    size = TagAlertSize.small as SizeTypes,
    children,
  } = props;

  return (
    <Box palette={palette} size={size}>
      <AlertIcon {...{ palette, size }}>{children}</AlertIcon>
      <TextParent {...{ palette, size }}>{children}</TextParent>
    </Box>
  );
};
